export const hotArticles = [
  {
    id: 1,
    title: "某顶流男星深夜密会神秘女子，酒店同进同出被拍",
    excerpt: "据知情人士透露，两人已经交往超过半年，女方身份引网友狂猜",
    category: "明星八卦",
    image: "https://readdy.ai/api/search-image?query=Blurred%20paparazzi%20night%20street%20scene%20with%20luxury%20hotel%20entrance%2C%20mysterious%20atmosphere%2C%20warm%20golden%20street%20lights%2C%20cinematic%20film%20grain%20texture%2C%20dark%20moody%20tones%2C%20editorial%20gossip%20magazine%20style%20photography&width=800&height=600&seq=article-hot-01&orientation=landscape",
    badge: "独家",
    hotIndex: 98,
    date: "2026-07-05",
    author: "吃瓜前线",
    views: 128900,
    comments: 3421
  },
  {
    id: 2,
    title: "网红圈又出大瓜！千万粉博主被曝虚假人设，粉丝集体脱粉",
    excerpt: "多位前员工实名爆料，揭露网红背后的真实面目，品牌方紧急解约",
    category: "网红爆料",
    image: "https://readdy.ai/api/search-image?query=Dramatic%20social%20media%20influencer%20studio%20setup%20with%20ring%20light%20and%20camera%2C%20behind%20the%20scenes%20chaos%2C%20warm%20indoor%20lighting%2C%20editorial%20documentary%20style%2C%20moody%20atmosphere%2C%20sharp%20contrast&width=800&height=600&seq=article-hot-02&orientation=landscape",
    badge: "热榜",
    hotIndex: 95,
    date: "2026-07-05",
    author: "爆料君",
    views: 98700,
    comments: 2890
  },
  {
    id: 3,
    title: "某综艺节目录制现场突发意外，导演组紧急叫停",
    excerpt: "现场观众爆料节目环节出现重大失误，多位明星面露不悦",
    category: "综艺八卦",
    image: "https://readdy.ai/api/search-image?query=TV%20show%20recording%20studio%20set%20with%20bright%20stage%20lights%20and%20cameras%2C%20tense%20atmosphere%2C%20crew%20members%20rushing%2C%20behind%20the%20scenes%20documentary%20photography%2C%20dramatic%20lighting%2C%20editorial%20style&width=800&height=600&seq=article-hot-03&orientation=landscape",
    badge: "独家",
    hotIndex: 92,
    date: "2026-07-04",
    author: "前线记者",
    views: 86700,
    comments: 2105
  },
  {
    id: 4,
    title: "年度最大反转！被骂三年的艺人终于拿出实锤证据",
    excerpt: "沉寂多年的艺人突然放出关键证据，舆论瞬间转向，网友直呼被打脸",
    category: "明星八卦",
    image: "https://readdy.ai/api/search-image?query=Dramatic%20courtroom%20or%20press%20conference%20scene%20with%20documents%20on%20table%2C%20serious%20atmosphere%2C%20warm%20spotlight%20effect%2C%20cinematic%20color%20grading%2C%20tension%20filled%20editorial%20photography%2C%20professional%20setting&width=800&height=600&seq=article-hot-04&orientation=landscape",
    badge: "热榜",
    hotIndex: 90,
    date: "2026-07-04",
    author: "深度报道",
    views: 76500,
    comments: 1876
  },
  {
    id: 5,
    title: "知名企业家私生活曝光，与多位女星关系成谜",
    excerpt: "圈内人士独家爆料某商业大佬的情感纠葛，涉及多位知名女艺人",
    category: "商业八卦",
    image: "https://readdy.ai/api/search-image?query=Luxury%20business%20event%20or%20gala%20dinner%20scene%20with%20elegant%20guests%2C%20mysterious%20vibe%2C%20warm%20chandelier%20lighting%2C%20high%20society%20atmosphere%2C%20editorial%20magazine%20photography%2C%20soft%20bokeh%20background&width=800&height=600&seq=article-hot-05&orientation=landscape",
    badge: "独家",
    hotIndex: 87,
    date: "2026-07-03",
    author: "财经八卦",
    views: 65400,
    comments: 1543
  },
  {
    id: 6,
    title: "某选秀节目选手被曝学历造假，节目组深夜发声明",
    excerpt: "网友扒出选手真实学历与其宣称严重不符，节目组连夜回应",
    category: "综艺八卦",
    image: "https://readdy.ai/api/search-image?query=Talent%20show%20stage%20with%20spotlight%20and%20microphone%2C%20dramatic%20atmosphere%2C%20emotional%20moment%2C%20warm%20stage%20lighting%20with%20smoke%20effect%2C%20television%20production%20style%2C%20cinematic%20photography&width=800&height=600&seq=article-hot-06&orientation=landscape",
    badge: "热榜",
    hotIndex: 85,
    date: "2026-07-03",
    author: "选秀观察",
    views: 58900,
    comments: 1320
  },
  {
    id: 7,
    title: "圈内金牌经纪人跳槽内幕曝光，带走多位一线艺人",
    excerpt: "娱乐圈大地震！知名经纪公司核心人物出走，背后原因令人唏嘘",
    category: "行业八卦",
    image: "https://readdy.ai/api/search-image?query=Modern%20office%20building%20lobby%20with%20glass%20walls%20and%20art%20deco%20elements%2C%20professional%20atmosphere%2C%20warm%20evening%20light%2C%20corporate%20drama%20mood%2C%20editorial%20business%20photography%2C%20elegant%20composition&width=800&height=600&seq=article-hot-07&orientation=landscape",
    badge: "独家",
    hotIndex: 83,
    date: "2026-07-02",
    author: "行业揭秘",
    views: 52100,
    comments: 1108
  },
  {
    id: 8,
    title: "某古装剧剧组内部矛盾升级，男女主角片场零交流",
    excerpt: "剧组工作人员爆料两位主演因番位问题产生矛盾，拍摄进度受影响",
    category: "影视八卦",
    image: "https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20film%20set%20with%20traditional%20costumes%20and%20props%2C%20behind%20the%20scenes%20tension%2C%20warm%20natural%20outdoor%20lighting%2C%20cinematic%20period%20drama%20atmosphere%2C%20editorial%20photography&width=800&height=600&seq=article-hot-08&orientation=landscape",
    badge: "热榜",
    hotIndex: 80,
    date: "2026-07-02",
    author: "剧组揭秘",
    views: 48300,
    comments: 987
  }
];

export const categories = [
  { slug: "star-gossip", name: "明星八卦", icon: "ri-star-line", count: 1256, description: "娱乐圈最新最热的明星八卦爆料" },
  { slug: "influencer-expose", name: "网红爆料", icon: "ri-live-line", count: 893, description: "网红圈一手爆料与真实面目" },
  { slug: "variety-gossip", name: "综艺八卦", icon: "ri-tv-line", count: 567, description: "综艺节目幕后故事与选手爆料" },
  { slug: "film-gossip", name: "影视八卦", icon: "ri-film-line", count: 432, description: "电影电视剧拍摄内幕与剧组爆料" },
  { slug: "biz-gossip", name: "商业八卦", icon: "ri-briefcase-line", count: 321, description: "商界大佬与娱乐圈的跨界八卦" },
  { slug: "industry-gossip", name: "行业八卦", icon: "ri-building-line", count: 289, description: "娱乐圈行业动态与内部消息" },
  { slug: "daily-contest", name: "每日大赛", icon: "ri-fire-line", count: 1098, description: "每日最热吃瓜话题大赛投票" },
  { slug: "social-gossip", name: "社会八卦", icon: "ri-global-line", count: 654, description: "社会热点事件与民间八卦" },
  { slug: "positive-energy", name: "正能量", icon: "ri-heart-line", count: 432, description: "黑料中的正能量故事与反转" }
];

export const dailyContestEntries = [
  { id: 1, title: "某女星整容前后对比惊人，医生都被吓到", votes: 28400, trend: "up", rank: 1 },
  { id: 2, title: "两位顶流为抢代言暗地里互撕，品牌方左右为难", votes: 25100, trend: "up", rank: 2 },
  { id: 3, title: "某综艺节目暗箱操作证据曝光，冠军早已内定", votes: 22800, trend: "up", rank: 3 },
  { id: 4, title: "知名导演潜规则女演员录音流出", votes: 19600, trend: "down", rank: 4 },
  { id: 5, title: "某选秀节目导师收钱内定晋级名额", votes: 17300, trend: "up", rank: 5 }
];

export const communityStats = {
  totalMembers: 2860000,
  totalPosts: 15890000,
  dailyActive: 358000,
  monthlyGrowth: 23.5
};

export const testimonials = [
  {
    name: "资深吃瓜群众小王",
    role: "社区元老 / 5年瓜龄",
    quote: "从大学就开始在91吃瓜蹲瓜了，这里的瓜又大又甜！信息更新快，爆料真实度高，社区氛围也特别好，瓜友们都很友善。现在每天不刷一刷就浑身难受，已经成生活必需品了。",
    image: "https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20casual%20portrait%20in%20urban%20setting%2C%20natural%20light%2C%20warm%20tones%2C%20friendly%20expression%2C%20modern%20casual%20style%2C%20editorial%20portrait%20photography%2C%20clean%20neutral%20background&width=400&height=500&seq=testimonial-01&orientation=portrait"
  },
  {
    name: "娱乐记者老李",
    role: "媒体从业者 / 社区认证用户",
    quote: "作为从业十年的娱记，91吃瓜的信息源质量让我惊讶。很多圈内人都在这潜水，爆料的准确率远超其他平台。关键是这里的讨论氛围理性客观，不像其他平台那样充满戾气。",
    image: "https://readdy.ai/api/search-image?query=Middle%20aged%20Chinese%20man%20professional%20portrait%2C%20wearing%20glasses%2C%20confident%20expression%2C%20modern%20office%20background%2C%20warm%20lighting%2C%20editorial%20portrait%20photography%2C%20clean%20composition&width=400&height=500&seq=testimonial-02&orientation=portrait"
  }
];

export const faqs = [
  {
    question: "91吃瓜社区的爆料内容靠谱吗？",
    answer: "我们有着严格的爆料审核机制，所有爆料内容都会经过多重交叉验证才会被推荐到首页。社区还设有'实锤认证'标签系统，经过时间验证的爆料会获得专属标识。当然，吃瓜需谨慎，建议大家理性看待每一则爆料信息。"
  },
  {
    question: "如何在91吃瓜社区发布自己的爆料？",
    answer: "注册成为社区成员后，你可以在任意板块发布爆料帖子。我们鼓励大家提供真实可靠的信息来源。发布时请遵守社区规范，不得散布谣言和虚假信息。优质爆料帖会获得流量扶持和积分奖励。"
  },
  {
    question: "每日大赛是什么？怎么参与？",
    answer: "每日大赛是91吃瓜社区最受欢迎的互动板块！每天中午12点，我们会精选当日最热的5条爆料话题进行投票PK。每位用户每天有3张投票权，可以投给自己认为最劲爆的瓜。排名第一的话题将获得全天首页推荐位。"
  },
  {
    question: "91吃瓜社区收费吗？",
    answer: "完全免费！91吃瓜社区始终秉持'吃瓜自由'的理念，所有公开内容均免费浏览。我们也有付费会员专区提供更深度的独家深度报道和行业分析，但基础吃瓜功能永久免费开放。"
  },
  {
    question: "如何保护爆料人的隐私安全？",
    answer: "我们高度重视爆料人的隐私保护。社区采用匿名投稿系统，所有爆料来源信息采用端到端加密存储，即使社区管理员也无法查看原始投稿人信息。我们承诺永不泄露爆料人身份信息。"
  }
];

export const footerLinks = {
  explore: [
    { name: "明星八卦", href: "/category/star-gossip" },
    { name: "网红爆料", href: "/category/influencer-expose" },
    { name: "每日大赛", href: "/category/daily-contest" },
    { name: "综艺八卦", href: "/category/variety-gossip" }
  ],
  about: [
    { name: "关于我们", href: "/about" },
    { name: "社区规范", href: "/about#rules" },
    { name: "隐私政策", href: "/about#privacy" },
    { name: "联系我们", href: "/about#contact" }
  ],
  support: [
    { name: "帮助中心", href: "/about#help" },
    { name: "举报投诉", href: "/about#report" },
    { name: "商务合作", href: "/about#business" },
    { name: "加入我们", href: "/about#join" }
  ]
};